/**
 * Status faktury
 *
 * @export
 * @enum {number}
 */
export enum InvoiceStatus {
  APPROVED = 'APPROVED',
  NOT_APPROVED = 'NOT_APPROVED'
}
